import { css } from '@emotion/react';
import { withPrefix } from 'gatsby-link';

import { breakpoints, colors } from '@/styles';
import fonts, { p2r } from '@/styles/fonts';

import constants from '../../utils/constants';

const styles = css`
  .btn {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    padding: ${p2r(10)} 60px ${p2r(10)} 10px;
    overflow: hidden;
    font-size: ${p2r(16)};
    color: ${colors.white};
    text-decoration: none;
    cursor: pointer;
    background: ${colors.darkBlue};
    border-radius: 8px;
    transition: all 0.3s ease-out 0s;
    ${fonts.SecondaryMedium}

    @media(max-width: ${breakpoints.smallTablet}px) {
      padding-right: 50px;
    }

    a {
      padding-top: ${p2r(3)};
      margin-right: 15px;
      color: inherit;
      text-decoration: none;
      white-space: nowrap;

      &:focus,
      &:visited {
        color: ${colors.white};
        text-decoration: none;
      }
    }

    .arrow {
      position: absolute;
      right: 0;
      display: block;
      width: 45px;
      height: 40px;
      background-image: url(${withPrefix(constants.buttonArrowImage)});
      background-position: center;
      background-size: cover;

      &:after {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 15px;
        height: 15px;
        color: ${colors.deepBlue};
        content: '';
        border-top: 2px solid ${colors.darkBlue};
        border-right: 2px solid ${colors.darkBlue};
        transition: all 0.3s ease-out 0s;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }

    &:hover {
      background: ${colors.paleBlue};

      .arrow {
        &:after {
          border-top: 2px solid ${colors.paleBlue};
          border-right: 2px solid ${colors.paleBlue};
        }
      }
    }
  }
`;

export default styles;
